//Accordion
let accordion = document.querySelectorAll('.accordion');

if(accordion.length > 0){
  accordion.forEach((item) => {
    let accBlock = item.querySelector('.acc-block');
    let btn = item.querySelector('.acc-btn');

    btn.addEventListener('click', function(event){
      event.preventDefault();

      if(accBlock.classList.contains('active')){
        accBlock.classList.remove('active');
      } else {
        accBlock.classList.add('active');
      }
    });
  });
}

//Gallery
let galleryCon = document.querySelector('.gallery-container');
let gallerySwiper; // Declare a variable outside

if(galleryCon){
  gallerySwiper = new Swiper(galleryCon, {
    //slidesPerView: 1,
    spaceBetween: 0,
    zoom: true,
    freeMode: false,
    loop: true,
    autoHeight: true,
    mouseWheel: {
      releaseOnEdges: true,
    },
    navigation: {
      nextEl: galleryCon.querySelector(".swiper-button-next"),
      prevEl: galleryCon.querySelector(".swiper-button-prev"),
    },
    pagination: {
      el: galleryCon.querySelector(".swiper-pagination"),
      clickable: true,
    },
    breakpoints: {
      500: {
        //slidesPerView: 2,
        freeMode: true,
        //autoHeight: false
      },
    },
  });
}
// let galleryCon = document.querySelector(".gallery-container");
// let gallerySwiper;

// if (galleryCon) {
//   gallerySwiper = new Swiper(galleryCon, {
//     spaceBetween: 0,
//     zoom: {
//       maxRatio: 3,
//       toggle: false,
//     },
//     freeMode: false,
//     loop: true,
//     autoHeight: true,
//     mouseWheel: {
//       releaseOnEdges: true,
//     },
//     navigation: {
//       nextEl: galleryCon.querySelector(".swiper-button-next"),
//       prevEl: galleryCon.querySelector(".swiper-button-prev"),
//     },
//     pagination: {
//       el: galleryCon.querySelector(".swiper-pagination"),
//       clickable: true,
//     },
//     breakpoints: {
//       500: {
//         freeMode: true,
//       },
//     },
//   });

//   galleryCon.addEventListener("click", function () {
//     if (gallerySwiper.zoom.scale === 1) {
//       gallerySwiper.zoom.in();
//     } else {
//       gallerySwiper.zoom.out();
//     }
//   });
// }


//Inventory Display
// let selectDrop = document.querySelector('.product-atc select');

// if(selectDrop){
//   let quantityText = document.querySelectorAll('.top .quantity');
//   let priceText = document.querySelectorAll('.top .price');

//   selectDrop.addEventListener('change', function(event){
//     let selectedOption = event.target.selectedOptions[0];
//     let inventory = selectedOption.getAttribute('data-inventory');
//     console.log(inventory);
//     quantityText.forEach((item) => {
//       if(inventory == 0){
//         item.innerHTML = "Out of stock";
//       } else if(inventory < 5){
//         item.innerHTML = inventory + " in stock";
//       } else {
//         item.innerHTML = "In stock";
//       }
//     });
    
//     let price = selectedOption.getAttribute('data-price');
//     priceText.forEach((item) => {
//       let formattedPrice = Shopify.formatMoney(price).replace(/\.00$/, '');
//       item.innerHTML = formattedPrice;
//     });
    
//   });
// }

//Inventory Display + Variant Image Switch
let selectDrop = document.querySelector('.product-atc select');

if(selectDrop){
  let quantityText = document.querySelectorAll('.top .quantity');
  let priceText = document.querySelectorAll('.top .price');
  let swiperSlides = document.querySelectorAll('.gallery-container .swiper-slide');

  selectDrop.addEventListener('change', function(event){
    let selectedOption = event.target.selectedOptions[0];
    
    // --- Inventory Text ---
    let inventory = selectedOption.getAttribute('data-inventory');
    quantityText.forEach((item) => {
      if(inventory == 0){
        item.innerHTML = "Out of stock";
      } else if(inventory < 5){
        item.innerHTML = inventory + " in stock";
      } else {
        item.innerHTML = "In stock";
      }
    });

    // --- Price Text ---
    let price = selectedOption.getAttribute('data-price');
    priceText.forEach((item) => {
      let formattedPrice = Shopify.formatMoney(price).replace(/\.00$/, '');
      item.innerHTML = formattedPrice;
    });

    // --- Variant Image Switch ---
    let selectedVariantId = selectedOption.value;
    let found = false;

    swiperSlides.forEach((slide, index) => {
      const variantIds = slide.dataset.variantIds ? slide.dataset.variantIds.split(',') : [];

      if (variantIds.includes(selectedVariantId)) {
        found = true;
        gallerySwiper.slideTo(index); // Replace 'swiper' if your Swiper instance has a different name
      }
    });

    // Optional fallback: if no variant image, go to the first slide
    // if (!found) {
    //   swiper.slideTo(0);
    // }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId) {
    const select = document.querySelector(".variant-select");
    if(select === null) return;
    const option = select.querySelector(`option[value="${variantId}"]`);

    if (option) {
      option.selected = true;
      const event = new Event("change", { bubbles: true });
      select.dispatchEvent(event);
    }
  }
});

let zoomBtn = document.querySelectorAll('.zoom-btn');
zoomBtn.forEach((item) => {
  item.addEventListener('click', function(event){
    event.preventDefault();
  });
});
